<template>
  <div class="homePage">
    <div class="banner"><img :src="banner" /></div>
    <div class="synopsis"><img :src="synopsis" /></div>
    <div class="history"><img :src="history" /></div>
    <div class="contactUs">
      <div>
        <div class="subtitle">CONTACT US</div>

        <div class="title">联系我们</div>
        <img :src="contactUs" />
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'aboutUs',
  data() {
    return {
      banner: require("../../assets/img/aboutUs/banner.png"),
      synopsis: require("../../assets/img/aboutUs/synopsis.png"),
      history: require("../../assets/img/aboutUs/history.png"),
      contactUs: require("../../assets/img/aboutUs/contactUs.png"),

      // contactUs: require("../../assets/img/contactUs.png"),
      // plan: require("../../assets/img/plan.png"),
      // reason: require("../../assets/img/reason.png"),
      // toolList: [require("../../assets/img/tool1.png"), require("../../assets/img/tool2.png"), require("../../assets/img/tool3.png"), require("../../assets/img/tool4.png"), require("../../assets/img/tool5.png"), require("../../assets/img/tool6.png")]
    }
  }
}
</script>
<style lang="less" scoped>
.homePage {
  background: #FAFBFF;
  padding-top: 80px;

  img {
    width: 100%;

    display: block;
  }

  .banner {
    width: 100%;

    img {
      width: 100%;
      // height: 100%;
    }
  }

  .synopsis {
    padding: 0 320px 64px;
    margin-top: -420px;
    box-sizing: border-box;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .contactUs {
    padding: 64px 320px 100px;

    >div {
      padding: 40px 60px;
      background: #fff;
      position: relative;

      .title {
        font-weight: bold;
        font-size: 32px;
        color: #333333;
        position: absolute;
        top: 65px;

      }

      .subtitle {
        font-weight: normal;
        font-size: 47px;
        color: #E6E6E6;
        margin-bottom: 20px;
        margin-left: 40px;
        font-family: Helvetica Inserat, Helvetica Inserat;

      }
    }
  }

}
</style>
